import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';

export const getOneCmsUrl = (state) => state.getIn(['config', 'oneCMSInternetSSRBaseUrl']);

export const getFullOneCmsUrl = createSelector(
  getOneCmsUrl,
  getActiveLocaleSelector,
  (oneCMSInternetSSRBaseUrl, activeLocale) => `${oneCMSInternetSSRBaseUrl}/Internet/travel/common/${activeLocale.toLowerCase()}/travel-advisory.json`
);
